var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHolderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C6 0.447715 6.44772 0 7 0H8.58579C8.851 0 9.10536 0.105357 9.29289 0.292893L9.70711 0.707107C9.89464 0.894643 10.149 1 10.4142 1H13C13.5523 1 14 1.44772 14 2V6C14 6.55228 13.5523 7 13 7H7C6.44772 7 6 6.55228 6 6V1Z",
    fill: "#8A99F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10C12 9.44772 12.4477 9 13 9H14.5858C14.851 9 15.1054 9.10536 15.2929 9.29289L15.7071 9.70711C15.8946 9.89464 16.149 10 16.4142 10H19C19.5523 10 20 10.4477 20 11V15C20 15.5523 19.5523 16 19 16H13C12.4477 16 12 15.5523 12 15V10Z",
    fill: "#8A99F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 9.44772 0.447715 9 1 9H2.58579C2.851 9 3.10536 9.10536 3.29289 9.29289L3.70711 9.70711C3.89464 9.89464 4.149 10 4.41421 10H7C7.55228 10 8 10.4477 8 11V15C8 15.5523 7.55228 16 7 16H1C0.447715 16 0 15.5523 0 15V10Z",
    fill: "#8A99F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3L3 1.5V2.50001C2.77048 2.50015 2.57037 2.50157 2.40249 2.51528C2.20481 2.53144 2.0082 2.56709 1.81901 2.66349C1.53677 2.8073 1.3073 3.03677 1.16349 3.31901C1.06709 3.5082 1.03144 3.70481 1.01529 3.90249C0.999984 4.08977 0.999991 4.31714 0.999999 4.58071V8H2V4.6C2 4.31172 2.00039 4.12559 2.01196 3.98392C2.02306 3.84809 2.0419 3.79773 2.0545 3.773C2.10243 3.67892 2.17892 3.60243 2.27301 3.5545C2.29773 3.5419 2.34809 3.52306 2.48392 3.51196C2.60849 3.50179 2.76745 3.50026 3 3.50004V4.5L5 3Z",
    fill: "#8A99F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 3L17 1.5V2.50001C17.2295 2.50015 17.4296 2.50157 17.5975 2.51528C17.7952 2.53144 17.9918 2.56709 18.181 2.66349C18.4632 2.8073 18.6927 3.03677 18.8365 3.31901C18.9329 3.5082 18.9686 3.70481 18.9847 3.90249C19 4.08977 19 4.31715 19 4.58072V8H18V4.6C18 4.31172 17.9996 4.12559 17.988 3.98392C17.9769 3.84809 17.9581 3.79773 17.9455 3.773C17.8976 3.67892 17.8211 3.60243 17.727 3.5545C17.7023 3.5419 17.6519 3.52306 17.5161 3.51196C17.3915 3.50179 17.2326 3.50026 17 3.50004V4.5L15 3Z",
    fill: "#8A99F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHolderLogo);
export default __webpack_public_path__ + "static/media/holderLogo.531a595c73e8e4c6937dcb8470dd6903.svg";
export { ForwardRef as ReactComponent };